import { render, staticRenderFns } from "./VehicleSelectWidget.vue?vue&type=template&id=1ab72b52"
import script from "./VehicleSelectWidget.vue?vue&type=script&lang=js"
export * from "./VehicleSelectWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports